import { Card } from '@/shared/components/ui/card';

export const CarePlansSkeleton = () => {
  return (
    <div className="mt-8 animate-pulse">
      <div className="mb-4 h-8 w-56 rounded bg-gray-200" />

      <div className="flex flex-col gap-3">
        {[1, 2, 3].map((item) => (
          <Card
            key={item}
            className="rounded-2xl border border-gray-200 bg-white px-5 py-6 sm:px-8"
          >
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div className="flex-1 min-w-0">
                {/* Title */}
                <div className="h-6 w-64 rounded bg-gray-200" />

                {/* Description */}
                <div className="mt-3 space-y-2">
                  <div className="h-4 w-full rounded bg-gray-200" />
                  <div className="h-4 w-4/5 rounded bg-gray-200" />
                </div>

                {/* Date */}
                <div className="mt-4 flex items-center gap-2">
                  <div className="h-4 w-4 rounded bg-gray-200" />
                  <div className="h-4 w-40 rounded bg-gray-200" />
                </div>
              </div>

              {/* Button */}
              <div className="h-5 w-20 rounded bg-gray-200" />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};